import { render, staticRenderFns } from "./view-remote-proofing.vue?vue&type=template&id=4f842641&scoped=true&"
import script from "./view-remote-proofing.vue?vue&type=script&lang=js&"
export * from "./view-remote-proofing.vue?vue&type=script&lang=js&"
import style0 from "./view-remote-proofing.vue?vue&type=style&index=0&id=4f842641&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f842641",
  null
  
)

export default component.exports